import { Injectable } from '@angular/core';
import { Day, Itinerary, PointOfInterest } from './itineray.model';

@Injectable({
  providedIn: 'root'
})
export class GpxExporterService {

  constructor() { }

  exportGpx(itinerary: Itinerary, activeDays?: Day[]): string {

    const days = activeDays ? activeDays : itinerary.days;

    // https://stackoverflow.com/a/27979933
    function escapeXml(unsafe: string) {
      return unsafe.replace(/[<>&'"]/g, function (c) {
        switch (c) {
          case '<': return '&lt;';
          case '>': return '&gt;';
          case '&': return '&amp;';
          case '\'': return '&apos;';
          case '"': return '&quot;';
        }
      });
    }


    function getPoiString(poi: PointOfInterest, tag: string): string {
      const poiHeader = `
      <${tag} lat="${poi.place.position.latitude}" lon="${poi.place.position.longitude}">
      `;
      const poiFooter = `
      </${tag}>
      `;

      let poiContent = ``;

      if (poi.title) {
        poiContent += `
        <name><![CDATA[${poi.title}]]></name>
        `;
      }

      if (poi.description) {
        poiContent += `
        <desc><![CDATA[${poi.description}]]></desc>
        `;
      }

      if (poi.image && poi.image.url) {
        poiContent += `
        <link href="${escapeXml(poi.image.url)} "><text>Immagine</text><type>image/jpeg</type></link>
        `;
      }

      if (poi.link && (poi.link.shortUrl || poi.link.longUrl)) {
        poiContent += `
        <link href = "${escapeXml(poi.link.shortUrl ? poi.link.shortUrl : poi.link.longUrl)}" ></link>
          `;
      }

      return poiHeader + poiContent + poiFooter;
    }

    const header = `<?xml version="1.0" encoding="UTF-8"?>
<gpx xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.topografix.com/GPX/1/1" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd http://www.garmin.com/xmlschemas/GpxExtensions/v3 http://www.garmin.com/xmlschemas/GpxExtensionsv3.xsd http://www.garmin.com/xmlschemas/TrackPointExtension/v1 http://www.garmin.com/xmlschemas/TrackPointExtensionv1.xsd http://www.topografix.com/GPX/gpx_style/0/2 http://www.topografix.com/GPX/gpx_style/0/2/gpx_style.xsd" xmlns:gpxtpx="http://www.garmin.com/xmlschemas/TrackPointExtension/v1" xmlns:gpxx="http://www.garmin.com/xmlschemas/GpxExtensions/v3" xmlns:gpx_style="http://www.topografix.com/GPX/gpx_style/0/2">
  <metadata>
      <name><![CDATA[${itinerary.title}]]></name>
      <author>
          <name>QuoVado</name>
          <link href="https://www.quovado.com"></link>
      </author>
  </metadata>
`;

    const footer = `</gpx>`;

    let content = "";

    for (let d = 0; d < days.length; d++) {
      const day = days[d];

      const trkHeader = `
      <trk>
        <name><![CDATA[${itinerary.title + " - Giorno " + (d + 1)}]]></name>
        <link><![CDATA[${day.link.shortUrl ? day.link.shortUrl : day.link.longUrl}]]></link>
        <trkseg>
      `;
      const trkFooter = `
        </trkseg>
      </trk>
      `;

      content += trkHeader;
      for (let p = 0; p < day.pois.length; p++) {
        const poi = day.pois[p];
        if (poi.generated) {
          const poiString = getPoiString(poi, "trkpt");
          content += poiString;
        }
      }
      content += trkFooter;

      for (let p = 0; p < day.pois.length; p++) {
        const poi = day.pois[p];
        const poiString = getPoiString(poi, "wpt");
        content += poiString;
      }

    }

    return header + content + footer;
  }
}
